import React, { useState } from 'react';
import { Play, Pause, Volume2, VolumeX } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  const [isPaused, setIsPaused] = useState(false);

  return (
    <section className="hero container">
      <div className="hero-content">
        <div className="hero-text-content">
          <div className="badge-container">
            <div className="badge">
              <span className="live-dot"></span>
              StopSpoti v1.0
            </div>
            <div className="badge windows-badge">
              <svg viewBox="0 0 88 88" width="12" height="12" fill="currentColor">
                <path d="M0 12.402l35.687-4.86v34.453H0zm0 37.106h35.687v34.453L0 79.102zM39.691 6.309L88 0v41.996H39.691zM88 49.508v41.996L39.691 85.195V49.508z"/>
              </svg>
              Windows Only
            </div>
          </div>
          <h1 className="hero-title">
            Intelligent Audio <br />
            <span className="accent-text">Control.</span>
          </h1>
          <p className="hero-description">
            A zero-configuration utility that automatically pauses Spotify when you watch a video or play a game, and instantly resumes your music when they stop.
          </p>
          <div className="hero-cta-group">
            <a href="https://github.com/Shreeniwas1/stopspoti" target="_blank" rel="noopener noreferrer" className="cta-primary">
              Get Started
            </a>
            <a href="#installation" className="cta-secondary">
              View Instructions
            </a>
          </div>
        </div>

        <div className="hero-visual">
          <div 
            className={`interactive-island ${isPaused ? 'paused' : 'playing'}`}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            onClick={() => setIsPaused(!isPaused)}
          >
            <div className="island-header win-header">
              <div className="win-title">StopSpoti Monitoring</div>
              <div className="island-controls win-controls">
                <span className="win-min"></span>
                <span className="win-max"></span>
                <span className="win-close"></span>
              </div>
            </div>
            
            <div className="island-body">
              <div className="app-status">
                {isPaused ? (
                  <div className="status-badge alert">
                    <VolumeX size={16} /> Other App Playing
                  </div>
                ) : (
                  <div className="status-badge ok">
                    <Volume2 size={16} /> System Quiet
                  </div>
                )}
              </div>

              <div className="spotify-status">
                <div className="spotify-icon">
                   <svg viewBox="0 0 24 24" fill="var(--primary-color)">
                     <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
                   </svg>
                </div>
                <div className="song-info">
                  <h4>Spotify Playback</h4>
                  <p>{isPaused ? 'Auto-paused ⏸' : 'Playing... 🎵'}</p>
                </div>
              </div>

              {/* The SVG Animation Core */}
              <div className="waveform-container">
                 {isPaused ? <Pause size={32} className="state-icon pause-icon" /> : <Play size={32} className="state-icon play-icon" />}
                 <svg className={`waveform ${isPaused ? 'flatline' : 'active'}`} viewBox="0 0 100 40" preserveAspectRatio="none">
                    <path 
                      className="wave-path"
                      d="M0 20 Q 5 20, 10 20 T 20 20 T 30 20 T 40 20 T 50 20 T 60 20 T 70 20 T 80 20 T 90 20 T 100 20"
                      fill="none" 
                      stroke="var(--primary-color)" 
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                 </svg>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
